module.exports = __webpack_public_path__ + "static/media/wQ.518cd5f8.svg";